<template>
  <footer class="bg-footer text-white py-5">
    <div class="container">
      <div class="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4 pb-4">
        <div class="col-lg-4 col-md-12">
          <img
            src="@/assets/logo/logo-juf-financeiro-white.svg"
            alt="Logo"
            class="footer-logo mb-4"
          />
          <p class="mb-4">
            {{ $t('message.footer.aboutUs') }}
          </p>
          <div class="d-flex gap-3">
            <a
              href="https://www.facebook.com/Maia.JanelaUnica"
              target="_blank"
            >
              <img
                src="@/assets/icons/icon-facebook-white-min.svg"
                alt="Facebook"
              />
            </a>
            <a
              href="https://www.instagram.com/maia.tecnologia/"
              target="_blank"
            >
              <img
                src="@/assets/icons/icon-instagram-white-min.svg"
                alt="Instagram"
              />
            </a>
            <a
              href="https://wa.me/5591991707588"
              target="_blank"
            >
              <img
                src="@/assets/icons/icon-whatsapp-white-min.svg"
                alt="Whatsapp"
              />
            </a>
          </div>
        </div>

        <div class="col-lg-2 col-md-6">
          <h5 class="mb-3">{{ $t('message.footer.company') }}</h5>
          <ul class="list-unstyled">
            <li class="mb-2">
              <a
                href="#contact"
                class="text-white-50"
              >
                {{ $t('message.contact') }}
              </a>
            </li>
            <li>
              <a
                href="https://www.maiatecnologia.com.br/"
                target="_blank"
                class="text-white-50"
              >
                Maia Produção de Softwares
              </a>
            </li>
          </ul>
        </div>

        <div class="col-lg-3 col-md-6">
          <h5 class="mb-3">{{ $t('message.footer.juFinanceiro') }}</h5>
          <ul class="list-unstyled">
            <li class="mb-2">
              <router-link
                :to="{ name: 'terms' }"
                class="text-white-50"
              >
                {{ $t('message.terms') }}
              </router-link>
            </li>
            <li class="mb-2">
              <router-link
                :to="{ name: 'privacy-police' }"
                class="text-white-50"
              >
                {{ $t('message.privacyPolicy') }}
              </router-link>
            </li>
            <li class="mb-2">
              <router-link
                :to="{ name: 'help' }"
                class="text-white-50"
              >
                {{ $t('message.help') }}
              </router-link>
            </li>
          </ul>
        </div>

        <div class="col-lg-3 col-md-6">
          <h5 class="mb-3">{{ $t('message.footer.contact') }}</h5>
          <address class="not-italic text-white-50">
            <p class="mt-2">
              Travessa Barão do Triunfo, 3540A - Marco Belém - PA, sala: 813,
              CEP: 66095-055, Brasil
            </p>
            <p class="mt-3">Telefone: +55 (91) 99170-7588</p>
            <p class="mb-3">Email: comercial@jufinanceiro.com</p>
          </address>
        </div>
      </div>
      <div class="footer-nav">
        <router-link :to="{ name: 'home' }">
          {{ $t('message.home') }}
        </router-link>
        <router-link :to="{ name: 'link-hub' }">Link Hub</router-link>
        <router-link :to="{ name: 'nfse' }">NFSe</router-link>
        <router-link :to="{ name: 'features' }">
          {{ $t('message.functionalities') }}
        </router-link>
        <router-link :to="{ name: 'plans' }">
          {{ $t('message.plans') }}
        </router-link>
        <router-link :to="{ name: 'faq' }">{{ $t('message.faq') }}</router-link>
        <router-link :to="{ name: 'contact' }">
          {{ $t('message.contact') }}
        </router-link>
      </div>
      <hr class="text-white" />
      <div class="text-center pt-3">
        <p class="m-0 text-white-50">
          {{ $t('message.footer.copyright') }}
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterComponent',
}
</script>

<style scoped>
.bg-footer {
  background: var(--color-primary);
}

.footer-logo {
  max-width: 150px;
}

.d-flex a img {
  width: 32px;
  height: 32px;
  transition: transform 0.3s ease;
}

.d-flex a:hover img {
  transform: scale(1.1);
}

.list-unstyled a {
  color: var(--c4); /* Mantém a cor original para hover */
  letter-spacing: 0.5px;
  transition: color 0.3s ease;
}

.list-unstyled a:hover {
  color: var(--white) !important;
}

.footer-nav {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 20px;
}

.footer-nav a {
  color: var(--white);
  text-decoration: none;
  font-weight: bold;
  transition: color 0.3s ease;
}

.footer-nav a:hover {
  color: var(--c2);
}
</style>
